import React from 'react';

const RoleCard = ({ role, title, description, icon, isSelected, onSelect }) => {
  return (
    <button
      type="button"
      onClick={onSelect}
      className={`p-6 rounded-lg border-2 transition-all text-left hover:shadow-md ${
        isSelected
          ? 'border-primary bg-primary/10 shadow-md'
          : 'border-border bg-card hover:border-primary/50'
      }`}
    >
      <div className="flex items-center gap-3 mb-2">
        <span className="text-3xl">{icon}</span>
        <h3 className={`text-lg font-semibold ${
          isSelected ? 'text-foreground' : 'text-foreground'
        }`}>
          {title}
        </h3>
      </div>
      <p className={`text-sm ${
        isSelected ? 'text-primary' : 'text-muted-foreground'
      }`}>
        {description}
      </p>
    </button>
  );
};

export default RoleCard;